import { iconSize, IconSizeProps } from '@/types/icons';

export const IconCheck = ({ size }: Partial<IconSizeProps>) => {
  return (
    <svg
      fill="currentColor"
      className={iconSize[size]}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="10"
      viewBox="0 0 14 10"
      xmlSpace="preserve"
    >
      <path
        d="M5.82109 9.9768L5.79787 9.99992L0 4.22717L1.8879 2.34745L5.82117 6.26367L12.1121 0L14 1.87972L5.84438 10L5.82109 9.9768Z"
        fill="white"
      />
    </svg>
  );
};
